/**
 * Viewport awareness context for menu positioning.
 *
 * When a submenu would overflow the viewport, the entire menu shifts up.
 */

import type { RefCallback } from "react";
import { createContext, useContext } from "react";

export interface ViewportAwareContextValue {
  registerSubMenu: RefCallback<HTMLElement>;
  offset: number;
}

export const ViewportAwareContext =
  createContext<ViewportAwareContextValue | null>(null);

export function useViewportAware(): ViewportAwareContextValue | null {
  return useContext(ViewportAwareContext);
}
